/* global axios */
import ApiClient from './ApiClient';

class CampaignBlacklistsAPI extends ApiClient {
  constructor() {
    super('campaign_blacklists', { accountScoped: true });
  }

  check(phoneNumber) {
    return axios.get(`${this.url}/check`, {
      params: { phone_number: phoneNumber },
    });
  }

  bulkAdd(phoneNumbers, reason = 'bulk_import') {
    return axios.post(`${this.url}/bulk_add`, {
      phone_numbers: phoneNumbers,
      reason,
    });
  }

  bulkRemove(phoneNumbers) {
    return axios.post(`${this.url}/bulk_remove`, {
      phone_numbers: phoneNumbers,
    });
  }

  export() {
    return axios.get(`${this.url}/export`, {
      responseType: 'blob',
    });
  }
}

export default new CampaignBlacklistsAPI();
